import { render, staticRenderFns } from "./cddx_exam.vue?vue&type=template&id=738ce2df&scoped=true&"
import script from "./cddx_exam.vue?vue&type=script&lang=js&"
export * from "./cddx_exam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ce2df",
  null
  
)

export default component.exports